import { baseUrl } from '../../../network'

export const companyTransactionFiltersUrl = (companyId:number)=>baseUrl + `/api/company/${companyId}/transactions/filters`
export const companyTransactionOverviewUrl = (companyId:number)=>baseUrl + `/api/company/${companyId}/transactions/overview`
export const companyTransactionsUrl = (companyId:number)=>baseUrl + `/api/company/${companyId}/transactions`

export const singleTransactionUrl = (transactionId:number)=> baseUrl + `/api/transaction/${transactionId}`